import { supabase } from './supabaseClient';

export const RSA_TICKET_SERVICE_TYPES = [
  'Jump Start',
  'Towing',
  'Flat Tyre',
  'Minor Repair',
  'Key Lockout',
  'Fuel Delivery',
];

export class PartnerTicketService {
  static async listProducts() {
    const { data, error } = await supabase.rpc('admin_list_partner_ticket_products');
    if (error) throw error;
    return Array.isArray(data) ? data : [];
  }

  static async upsertProduct(payload) {
    const price = Number(payload.price_inr);
    const creditsRaw = payload.credits_inr;
    const credits =
      creditsRaw === '' || creditsRaw == null || Number.isNaN(Number(creditsRaw))
        ? price
        : Number(creditsRaw);
    const { data, error } = await supabase.rpc('admin_upsert_partner_ticket_product', {
      p_id: payload.id || null,
      p_name: payload.name,
      p_description: payload.description || null,
      p_price_inr: price,
      p_tickets_count: Number(payload.tickets_count),
      p_allowed_service_types: payload.allowed_service_types || [],
      p_active: payload.active !== false,
      p_sort_order: Number(payload.sort_order) || 0,
      p_credits_inr: credits,
    });
    if (error) throw error;
    const parsed = data || {};
    if (!parsed.success) throw new Error(parsed.error || 'Save failed');
    return parsed.product;
  }

  static async listPurchases(limit = 50) {
    const { data, error } = await supabase.rpc('admin_list_partner_ticket_purchases', {
      p_limit: limit,
    });
    if (error) throw error;
    return Array.isArray(data) ? data : [];
  }
}
